import React, { useState, useEffect } from 'react';
import { toast } from 'sonner';
import { Button } from './ui/button';
import { useAuth } from '../context/AuthContext';

/**
 * Login sonrası KVKK/yaş/ToS onayı eksik kullanıcılara modal gösterir.
 * Tetik koşulu: user var + (kvkk_accepted_at == null || terms_accepted_at == null || age_confirmed_at == null).
 * Kayıt form'undaki üç checkbox ile aynı içerik, fakat existing hesaplar için.
 */
const LegalAcceptanceGate = () => {
  const { user, loading, acceptLegal } = useAuth();
  const [ageConfirmed, setAgeConfirmed] = useState(false);
  const [kvkkAccepted, setKvkkAccepted] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const needsAcceptance =
    !loading &&
    !!user &&
    (!user.age_confirmed_at || !user.kvkk_accepted_at || !user.terms_accepted_at);

  useEffect(() => {
    if (!needsAcceptance) {
      setAgeConfirmed(false);
      setKvkkAccepted(false);
      setTermsAccepted(false);
    }
  }, [needsAcceptance]);

  if (!needsAcceptance) return null;

  const submit = async () => {
    if (!ageConfirmed || !kvkkAccepted || !termsAccepted) {
      toast.error('Tüm onaylar zorunludur.');
      return;
    }
    setSubmitting(true);
    try {
      await acceptLegal();
      toast.success('Teşekkürler. Onayınız kaydedildi.');
    } catch (err) {
      const detail = err?.response?.data?.detail || 'Onay kaydedilemedi.';
      toast.error(typeof detail === 'string' ? detail : JSON.stringify(detail));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[120] bg-black/85 backdrop-blur-sm flex items-center justify-center px-4 py-6">
      <div className="w-full max-w-md glass-effect rounded-2xl p-6 border border-white/10 shadow-xl">
        <h2 className="text-lg font-semibold text-white mb-2">Devam etmeden önce</h2>
        <p className="text-xs text-zinc-400 leading-snug mb-4">
          Hesabınızda yasal onaylar tamamlanmamış. Hizmeti kullanmaya devam edebilmek için aşağıdaki
          maddeleri onaylayın.
        </p>

        <div className="space-y-2 text-[12px] leading-snug text-zinc-300">
          <label className="flex items-start gap-2 cursor-pointer">
            <input
              type="checkbox"
              checked={ageConfirmed}
              onChange={(e) => setAgeConfirmed(e.target.checked)}
              className="mt-0.5 accent-violet-500"
            />
            <span>13 yaş ve üzerinde olduğumu beyan ederim.</span>
          </label>
          <label className="flex items-start gap-2 cursor-pointer">
            <input
              type="checkbox"
              checked={kvkkAccepted}
              onChange={(e) => setKvkkAccepted(e.target.checked)}
              className="mt-0.5 accent-violet-500"
            />
            <span>
              <a href="/kvkk" target="_blank" rel="noreferrer" className="text-violet-400 hover:text-violet-300 underline">
                KVKK aydınlatma metnini
              </a>{' '}
              okudum ve kabul ediyorum.
            </span>
          </label>
          <label className="flex items-start gap-2 cursor-pointer">
            <input
              type="checkbox"
              checked={termsAccepted}
              onChange={(e) => setTermsAccepted(e.target.checked)}
              className="mt-0.5 accent-violet-500"
            />
            <span>
              <a href="/terms" target="_blank" rel="noreferrer" className="text-violet-400 hover:text-violet-300 underline">
                Kullanım koşullarını
              </a>{' '}
              ve{' '}
              <a href="/privacy" target="_blank" rel="noreferrer" className="text-violet-400 hover:text-violet-300 underline">
                gizlilik politikasını
              </a>{' '}
              kabul ediyorum.
            </span>
          </label>
        </div>

        <Button
          type="button"
          onClick={submit}
          disabled={submitting || !ageConfirmed || !kvkkAccepted || !termsAccepted}
          className="w-full mt-5 h-11 btn-primary font-semibold"
        >
          {submitting ? 'Kaydediliyor...' : 'Onaylıyorum ve devam et'}
        </Button>

        <p className="text-[10px] text-zinc-500 text-center mt-3 leading-snug">
          Bu pencere kapatılamaz. Onaylamadan hizmeti kullanamazsınız. Hesabınızı tamamen silmek isterseniz
          giriş yapmadan{' '}
          <a href="mailto:destek@dekosta.com" className="text-violet-400 hover:text-violet-300 underline">
            destek
          </a>{' '}
          ile iletişime geçin.
        </p>
      </div>
    </div>
  );
};

export default LegalAcceptanceGate;
